import { SET_ALL_USERS, RESET_ALL_USERS } from "@redux/constants";

const initialState = {
    allUsers: [], // Store all users
    userSearchEmail: "", // Optional: Store the search email if needed
};

export const allUsersReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_ALL_USERS:
            return {
                ...state,
                allUsers: payload, // Update the allUsers array
            };
        case RESET_ALL_USERS:
            return initialState; // Reset to the initial state
        default:
            return state;
    }
};
